import { observable } from 'mobx';

class ModalStore {
  @observable accessor showModal;
  @observable accessor modalHeader;
  @observable accessor modalText;

  constructor() {
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal(data) {
    this.showModal = true;
    this.modalHeader = data.header;
    this.modalText = data.text;
  }

  closeModal() {
    this.showModal = false;
  }
}

const ModalData = new ModalStore();

export default ModalData;
